import { microFrontListener } from '@b2ag/micro-front-tools'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'

/* ------- MICROFRONT - PREVIEW ------- */

export const previewRoutes = [
  {
    path: '/preview/:type/:id',
    name: 'preview',
    component: () => import('@b2ag/micro-front-preview/app'),
    props: () => ({
      microFrontName: 'preview',
      viewName: 'default',
    }),
    beforeEnter() {
      if (import.meta.browser)
        microFrontListener({
          iframe: { href: window.location.origin },
          analyticService: useAnalyticService(),
        } as any)
    },
    meta: {
      hideHeaderMenu: false,
    },
  },
]
